import { generators } from './data/data.generators';

export const tool = {
  name: 'add-model',
  description: 'A tool that adds a 3D model from a predefined list of available model generators.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      generatorId: {
        type: 'string',
        enum: generators,
        description: 'The ID and name of the model to be added.',
      },
      message: {
        type: 'string',
        default: 'Add selected model to the scene',
      },
    },
    required: ['generatorId', 'message'],
  },
};
